// @ts-nocheck
import { IBidPackageResponse, IBidResponse } from "@vmosolutions/oc-interfaces";
import AmplifyAPIWrapper from "src/API/AmplifyAPIWrapper";

//interface IBidAggResult {
//  userId: ObjectId;
//  pairingBids: number;
//  nfaBids: number;
//  bidId: ObjectId;
//}
export interface ICrewBid {
  userId: string;
  pairingBids: 0;
  nfaBids: 0;
  bidId: string;
}

export const getBidPackage = async (packageId: string): Promise<IBidPackageResponse> => {
  const response: IBidPackageResponse | any = await AmplifyAPIWrapper.Get(`/bidding/package/${packageId}`, null);
  return response;
};

// export const getAllBidPackages = async (updateMosaicWindow: (bidpackage: IBidPackage) => void): Promise<void> => {
//   const response: IBidPackageResponseListItem[] = await AmplifyAPIWrapper.Get("/bidding/packages", null);
//   if (Array.isArray(response)) {
//     console.log("get packages: ", response);
//     const firstPackage = response[0];
//     //@ts-ignore
//     updateMosaicWindow(firstPackage);
//   }
// };

//TODO investigate issue where dates types and nfaTypes are causing typescript linter errors.
export const testPayload: any = {
  isDisabled: false,
  bidWindowOpen: "2022-08-01T00:00:00.000Z",
  bidWindowClose: "2022-08-05T00:00:00.000Z",
  bidBlockStart: "2022-08-07T00:00:00.000Z",
  bidBlockEnd: "2022-08-30T00:00:00.000Z",
  releaseScheduleAt: "2022-08-06T00:00:00.000Z",
  title: "",
  nonFlyingAssignments: [
    {
      nfaType: {
        _id: "61441236f3fa7f38907687bb",
        _old_id: null,
        _old_OC: null,
        title: "SMB",
        description: "Simulator B",
        allowableOnPairing: true,
        defaultColor: "6FF2F9",
        isDuty: true,
        earnsPerDiemDefault: true,
        earnsMealAllowanceDefault: false,
        defaultCreditRate: 1.0,
        defaultMinCredit: 4.0,
        isActiveAssignment: true,
        isDayOff: false,
        visibleBeforeRelease: false,
        canBankDuty: true,
        enabled: true,
        createdBy: "000000000000000000000000",
        createdAt: 867661001,
        startTime: {
          hours: 8.0,
          minutes: 5.0,
        },
        endTime: {
          hours: 15.0,
          minutes: 45.0,
        },
        reserveType: 0,
        isOnDutyRest: false,
        thirdPartyRef: {},
        foreignRef: [],
      },
      maxAmount: 2,
    },
    {
      nfaType: {
        isOnDutyRest: false,
        _id: "60b408367fa31275b433879d",
        _old_id: null,
        _old_OC: null,
        id: "60b408367fa31275b433879d",
        title: "ACP",
        description: "ACP Course",
        allowableOnPairing: true,
        defaultColor: "6FF2F9",
        isDuty: true,
        earnsPerDiemDefault: true,
        earnsMealAllowanceDefault: false,
        defaultCreditRate: 1,
        defaultMinCredit: 4,
        isActiveAssignment: true,
        isDayOff: false,
        visibleBeforeRelease: false,
        canBankDuty: true,
        enabled: true,
        createdBy: "000000000000000000000000",
        createdAt: 867661001,
        endTime: {
          hours: 17,
          minutes: 0,
        },
        startTime: {
          hours: 9,
          minutes: 0,
        },
        reserveType: 0,
        foreignRef: [],
      },
      maxAmount: 2,
    },
  ],
  positions: ["CA"],
  crewGroups: [],
};

export const crewBidPackageMockData: IBidResponse = {
  "6090c34a3e4804ec36f1ca72": {
    bidPackageId: "631f45f162e1c20009b4395f",
    isDone: false,
    isDoneBy: null,
    isDoneAt: null,
    note: null,
    bids: {
      "1": {
        displayBidPairings: [
          {
            _id: "631848decc7f3a000927ca65",
            baseICAO: "CYHM",
            positions: [
              {
                position: "CA",
                openFlyingStatus: 1,
              },
              {
                position: "FO",
                openFlyingStatus: 1,
              },
            ],
            start: 1664141820000,
            end: 1664164920000,
            eventGroups: [
              {
                flights: [
                  {
                    _id: "6311f81a8625d90009474eb8",
                    flightNumber: 993,
                    origin: "CYHM",
                    destination: "KCVG",
                    actualOut: 1664145420000,
                    actualIn: 1664150400000,
                    flightType: {
                      color: "009933",
                    },
                  },
                  {
                    _id: "6311f81b8625d90009474ed8",
                    flightNumber: 994,
                    origin: "KCVG",
                    destination: "CYHM",
                    actualOut: 1664159400000,
                    actualIn: 1664164020000,
                    flightType: {
                      color: "009933",
                    },
                  },
                ],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
            ],
            logicModifiers: [],
            shortId: "2JNK",
            checkInOutOverrides: [],
            shortDescription: "993/994",
            bidPairingId: "631f467e082a02e32a1a6c19",
            awarded: false,
            awardedAt: null,
            awardedBy: null,
            assigned: false,
            prefRank: 1,
            createdAt: "2022-09-12T19:05:46.411Z",
          },
          {
            _id: "630f777f6dcac80009a65728",
            baseICAO: "CYHM",
            positions: [
              {
                position: "CA",
                openFlyingStatus: 1,
              },
              {
                position: "FO",
                openFlyingStatus: 1,
              },
            ],
            start: 1664304180000,
            end: 1664534100000,
            eventGroups: [
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "630f777f6dcac80009a6572d",
                    origin: "CYHM",
                    destination: "CYYZ",
                    outTime: 1664305080000,
                    inTime: 1664308380000,
                    airlineIATA: "LM",
                    flightNumber: 0,
                  },
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "630f777f6dcac80009a6572e",
                    origin: "CYYZ",
                    destination: "KMIA",
                    outTime: 1664315580000,
                    inTime: 1664327400000,
                    airlineIATA: "AA",
                    flightNumber: 1572,
                  },
                ],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [
                  {
                    _id: "630e1ea5e7354e0009bb3331",
                    flightNumber: 1557,
                    origin: "KMIA",
                    destination: "SCEL",
                    actualOut: 1664398800000,
                    actualIn: 1664430300000,
                    flightType: {
                      color: "009933",
                    },
                  },
                ],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "630f777f6dcac80009a6572f",
                    origin: "SCEL",
                    destination: "CYYZ",
                    outTime: 1664489700000,
                    inTime: 1664528700000,
                    airlineIATA: "AC",
                    flightNumber: 93,
                  },
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "630f777f6dcac80009a65730",
                    origin: "CYYZ",
                    destination: "CYHM",
                    outTime: 1664529900000,
                    inTime: 1664533200000,
                    airlineIATA: "LM",
                    flightNumber: 0,
                  },
                ],
                groundEvents: [],
              },
            ],
            logicModifiers: [],
            shortId: "QHZV",
            checkInOutOverrides: [
              {
                inout: true,
                time: 1664304180000,
                eventGroup: 0,
              },
            ],
            shortDescription: "[LM0]/[AA1572]/<KMIA^1>/1557/<SCEL>/[AC93]/[LM0]",
            bidPairingId: "631f467e082a02e32a1a6c2b",
            awarded: false,
            awardedAt: null,
            awardedBy: null,
            assigned: false,
            prefRank: 1,
            createdAt: "2022-09-12T19:25:27.156Z",
          },
          {
            _id: "630f7573398c640009510d74",
            baseICAO: "CYHM",
            positions: [
              {
                position: "CA",
                openFlyingStatus: 1,
              },
              {
                position: "FO",
                openFlyingStatus: 1,
              },
              {
                position: "FO",
                openFlyingStatus: 1,
              },
            ],
            start: 1663630500000,
            end: 1663947540000,
            eventGroups: [
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "630f7573398c640009510d7b",
                    origin: "CYHM",
                    destination: "CYYZ",
                    outTime: 1663631400000,
                    inTime: 1663634700000,
                    airlineIATA: "",
                    flightNumber: 0,
                  },
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "630f7573398c640009510d7c",
                    origin: "CYYZ",
                    destination: "SCEL",
                    outTime: 1663641900000,
                    inTime: 1663679400000,
                    airlineIATA: "AC",
                    flightNumber: 92,
                  },
                ],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [
                  {
                    _id: "630e1ea5e7354e0009bb333b",
                    flightNumber: 1558,
                    origin: "SCEL",
                    destination: "KMIA",
                    actualOut: 1663832400000,
                    actualIn: 1663863900000,
                    flightType: {
                      color: "009933",
                    },
                  },
                ],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "630f76760a38830009ec7850",
                    origin: "KMIA",
                    destination: "CYYZ",
                    outTime: 1663930800000,
                    inTime: 1663942140000,
                    airlineIATA: "AC",
                    flightNumber: 1201,
                  },
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "630f76760a38830009ec7851",
                    origin: "CYYZ",
                    destination: "CYHM",
                    outTime: 1663943340000,
                    inTime: 1663946640000,
                    airlineIATA: "LM",
                    flightNumber: 0,
                  },
                ],
                groundEvents: [],
              },
            ],
            logicModifiers: [],
            shortId: "9H42",
            checkInOutOverrides: [
              {
                inout: true,
                time: 1663630500000,
                eventGroup: 0,
              },
            ],
            shortDescription: "[0]/[AC92]/<SCEL^2>/1558/<KMIA>/[AC1201]/[LM0]",
            bidPairingId: "631f467e082a02e32a1a6c2d",
            awarded: false,
            awardedAt: null,
            awardedBy: null,
            assigned: false,
            prefRank: 1,
            createdAt: "2022-09-12T19:27:09.281Z",
          },
        ],
        displayBidNFAs: [
          {
            _id: "631fd50481bdfe0bf9ef1926",
            start: 1666584000000,
            end: 1666670399999,
            locationICAO: "CYHM",
            locationTimezoneId: "America/Toronto",
            crew: [
              {
                _id: "6090c34a3e4804ec36f1c96c",
                firstName: "Rahul",
                lastName: "Aggarwal",
                email: "raggarwal@cargojet.com",
                crewInfo: {
                  positions: ["CA", "NF"],
                },
              },
            ],
            assignmentType: {
              _id: "6086e97ac6923758d24a60aa",
              title: "GDO",
              defaultColor: "FFC000",
              visibleBeforeRelease: false,
              allowableOnPairing: false,
              isDuty: false,
            },
            tier: 7,
            awarded: false,
            awardedAt: null,
            awardedBy: null,
            prefRank: 1,
            createdAt: "2022-09-13T01:07:21.802Z",
          },
        ],
      },
      "2": {
        displayBidPairings: [
          {
            _id: "631f31c114d5ed0009698dfe",
            baseICAO: "CYVR",
            positions: [
              {
                position: "CA",
                openFlyingStatus: 0,
              },
            ],
            start: 1663684800000,
            end: 1663943700000,
            eventGroups: [
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "631f31c114d5ed0009698e01",
                    origin: "CYVR",
                    destination: "CYHM",
                    outTime: 1663688400000,
                    inTime: 1663703940000,
                    airlineIATA: "W8",
                    flightNumber: 2384,
                    flight_id: "62c6d05eb1ec9f0009780691",
                  },
                ],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [
                  {
                    _id: "631f31c114d5ed0009698e02",
                    location: "CYHM",
                    start: 1663768800000,
                    end: 1663783200000,
                    isFullDay: false,
                    assignmentType: {
                      _id: "61441236f3fa7f38907687bb",
                      title: "SMB",
                      defaultColor: "6FF2F9",
                    },
                  },
                ],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [
                  {
                    _id: "631f31c114d5ed0009698e04",
                    location: "CYHM",
                    start: 1663855200000,
                    end: 1663869600000,
                    isFullDay: false,
                    assignmentType: {
                      _id: "61441236f3fa7f38907687bb",
                      title: "SMB",
                      defaultColor: "6FF2F9",
                    },
                  },
                ],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "631f31c114d5ed0009698e06",
                    origin: "CYHM",
                    destination: "CYVR",
                    outTime: 1663925400000,
                    inTime: 1663942800000,
                    airlineIATA: "W8",
                    flightNumber: 909,
                    flight_id: "62c6c9c9b1ec9f000977ebfc",
                  },
                ],
                groundEvents: [],
              },
            ],
            logicModifiers: [],
            shortId: "JWLT",
            checkInOutOverrides: [],
            shortDescription: "[W82384]/<CYHM>/SMB/<CYHM^1>/SMB/<CYHM>/[W8909]",
            bidPairingId: "631f467e082a02e32a1a6bff",
            awarded: false,
            awardedAt: null,
            awardedBy: null,
            assigned: false,
            prefRank: 2,
            createdAt: "2022-09-12T18:48:29.351Z",
          },
          {
            _id: "6319f3dfe15a4e0009dd7ddb",
            baseICAO: "CYHM",
            positions: [
              {
                position: "CA",
                openFlyingStatus: 1,
              },
            ],
            start: 1663999800000,
            end: 1664140500000,
            eventGroups: [
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "6319f3dfe15a4e0009dd7dde",
                    origin: "CYHM",
                    destination: "CYVR",
                    outTime: 1664003400000,
                    inTime: 1664021400000,
                    airlineIATA: "W8",
                    flightNumber: 583,
                    flight_id: "62c6c8dab1ec9f000977e896",
                  },
                ],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [
                  {
                    _id: "62c6c9c9b1ec9f000977ebf6",
                    flightNumber: 910,
                    origin: "CYVR",
                    destination: "CYYC",
                    actualOut: 1664118300000,
                    actualIn: 1664123700000,
                    flightType: {
                      color: "009933",
                    },
                  },
                  {
                    _id: "62c6c9c9b1ec9f000977ebf4",
                    flightNumber: 910,
                    origin: "CYYC",
                    destination: "CYHM",
                    actualOut: 1664127300000,
                    actualIn: 1664139600000,
                    flightType: {
                      color: "009933",
                    },
                  },
                ],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
            ],
            logicModifiers: [
              {
                _id: "6319f3dfe15a4e0009dd7ddf",
                logicModifier: {
                  allowableOnDay: false,
                  allowableOnPairing: true,
                  allowableOn: "duty",
                  _id: "60306e09589a10f79999df7f",
                  custom: null,
                  title: "Line Training (LT)",
                  description: "Line Training",
                  isActive: true,
                  color: "079aa2",
                  createdAt: 1612777219293,
                  createdBy: "000000000000000000000000",
                  customSchema: null,
                  modifiedAt: 1612777219293,
                  id: "60306e09589a10f79999df7f",
                },
                id: "6319f3dfe15a4e0009dd7ddf",
              },
            ],
            shortId: "7J2V",
            checkInOutOverrides: [],
            shortDescription: "[W8583]/<CYVR^1>/910",
            bidPairingId: "631f467e082a02e32a1a6c07",
            awarded: false,
            awardedAt: null,
            awardedBy: null,
            assigned: false,
            prefRank: 2,
            createdAt: "2022-09-12T18:55:17.989Z",
          },
          {
            _id: "631846d5d1c9820009303ca4",
            baseICAO: "CYHM",
            positions: [
              {
                position: "CA",
                openFlyingStatus: 2,
              },
              {
                position: "FO",
                openFlyingStatus: 2,
              },
            ],
            start: 1663537020000,
            end: 1663560120000,
            eventGroups: [
              {
                flights: [
                  {
                    _id: "6311f81a8625d90009474eba",
                    flightNumber: 993,
                    origin: "CYHM",
                    destination: "KCVG",
                    actualOut: 1663540620000,
                    actualIn: 1663545600000,
                    flightType: {
                      color: "009933",
                    },
                  },
                  {
                    _id: "6311f81b8625d90009474ed6",
                    flightNumber: 994,
                    origin: "KCVG",
                    destination: "CYHM",
                    actualOut: 1663554600000,
                    actualIn: 1663559220000,
                    flightType: {
                      color: "009933",
                    },
                  },
                ],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
            ],
            logicModifiers: [],
            shortId: "UK2H",
            checkInOutOverrides: [],
            shortDescription: "993/994",
            bidPairingId: "631f467e082a02e32a1a6c1b",
            awarded: false,
            awardedAt: null,
            awardedBy: null,
            assigned: false,
            prefRank: 2,
            createdAt: "2022-09-12T19:07:33.155Z",
          },
          {
            _id: "6309434681b96400090e437a",
            baseICAO: "CYHM",
            positions: [
              {
                position: "CA",
                openFlyingStatus: 1,
              },
              {
                position: "FO",
                openFlyingStatus: 1,
              },
            ],
            start: 1664355600000,
            end: 1664513400000,
            eventGroups: [
              {
                flights: [
                  {
                    _id: "6307c20c5c94e4000947748e",
                    flightNumber: 245,
                    origin: "CYHM",
                    destination: "KEWR",
                    actualOut: 1664359200000,
                    actualIn: 1664364600000,
                    flightType: {
                      color: "009933",
                    },
                  },
                  {
                    _id: "62c6cbdeb1ec9f000977f249",
                    flightNumber: 245,
                    origin: "KEWR",
                    destination: "TXKF",
                    actualOut: 1664369100000,
                    actualIn: 1664376300000,
                    flightType: {
                      color: "009933",
                    },
                  },
                ],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [
                  {
                    _id: "62c6cbdbb1ec9f000977f1d1",
                    flightNumber: 246,
                    origin: "TXKF",
                    destination: "KJFK",
                    actualOut: 1664488800000,
                    actualIn: 1664496900000,
                    flightType: {
                      color: "009933",
                    },
                  },
                  {
                    _id: "6307c2085c94e40009477430",
                    flightNumber: 246,
                    origin: "KJFK",
                    destination: "CYHM",
                    actualOut: 1664507700000,
                    actualIn: 1664512500000,
                    flightType: {
                      color: "009933",
                    },
                  },
                ],
                nonFlyingAssignments: [
                  {
                    _id: "631bb5fd51c4d20009879a1f",
                    location: "KJFK",
                    start: 1664497800000,
                    end: 1664504100000,
                    isFullDay: false,
                    assignmentType: {
                      _id: "6086e97ac6923758d24a60cf",
                      title: "REST",
                      defaultColor: "780018",
                    },
                  },
                ],
                positioningFlights: [],
                groundEvents: [],
              },
            ],
            logicModifiers: [
              {
                _id: "631bb5fd51c4d20009879a1d",
                logicModifier: {
                  allowableOnDay: false,
                  allowableOnPairing: false,
                  allowableOn: "duty",
                  _id: "5f610eafa22f417d962dd6e3",
                  custom: {
                    isSplitDuty: true,
                  },
                  title: "SPLIT",
                  description: "Split Duty Day",
                  isActive: true,
                  color: "E68A00",
                  createdAt: 867661001,
                  createdBy: "000000000000000000000000",
                  customSchema:
                    '{"$schema":"http://json-schema.org/draft-07/schema","$id":"customSplitDuty","type":"object","title":"Custom Split Duty","description":"The root schema comprises the entire JSON document.","default":{},"additionalProperties":true,"required":["isSplitDuty"],"properties":{"isSplitDuty":{"$id":"#/properties/isSplitDuty","type":"boolean","title":"Is Split Duty","description":"","readOnly":true,"default":true}}}',
                  id: "5f610eafa22f417d962dd6e3",
                },
                dutyTime: 1664499300000,
                id: "631bb5fd51c4d20009879a1d",
              },
            ],
            shortId: "NGEZ",
            checkInOutOverrides: [],
            shortDescription: "245/<TXKF^1>/246/REST/246",
            bidPairingId: "631f467e082a02e32a1a6c3d",
            awarded: false,
            awardedAt: null,
            awardedBy: null,
            assigned: false,
            prefRank: 2,
            createdAt: "2022-09-12T19:40:57.209Z",
          },
        ],
        displayBidNFAs: [
          {
            _id: "631fd5ea81bdfe0bf9ef2f59",
            start: 1665892800000,
            end: 1665979199999,
            locationICAO: "CYHM",
            locationTimezoneId: "America/Toronto",
            crew: [
              {
                _id: "6090c34a3e4804ec36f1c96c",
                firstName: "Rahul",
                lastName: "Aggarwal",
                email: "raggarwal@cargojet.com",
                crewInfo: {
                  positions: ["CA", "NF"],
                },
              },
            ],
            assignmentType: {
              _id: "6086e97ac6923758d24a60aa",
              title: "GDO",
              defaultColor: "FFC000",
              visibleBeforeRelease: false,
              allowableOnPairing: false,
              isDuty: false,
            },
            tier: 3,
            awarded: false,
            awardedAt: null,
            awardedBy: null,
            prefRank: 2,
            createdAt: "2022-09-13T00:59:22.579Z",
          },
          {
            _id: "631fd65e81bdfe0bf9ef3c87",
            start: 1666584000000,
            end: 1666670399999,
            locationICAO: "CYHM",
            locationTimezoneId: "America/Toronto",
            crew: [
              {
                _id: "6090c34a3e4804ec36f1c96c",
                firstName: "Rahul",
                lastName: "Aggarwal",
                email: "raggarwal@cargojet.com",
                crewInfo: {
                  positions: ["CA", "NF"],
                },
              },
            ],
            assignmentType: {
              _id: "6086e97ac6923758d24a60aa",
              title: "GDO",
              defaultColor: "FFC000",
              visibleBeforeRelease: false,
              allowableOnPairing: false,
              isDuty: false,
            },
            tier: 9,
            awarded: false,
            awardedAt: null,
            awardedBy: null,
            prefRank: 2,
            createdAt: "2022-09-13T01:01:18.746Z",
          },
          {
            _id: "631fd75081bdfe0bf9ef5a6d",
            start: 1665115200000,
            end: 1665201599999,
            locationICAO: "CYHM",
            locationTimezoneId: "America/Toronto",
            crew: [
              {
                _id: "6090c34a3e4804ec36f1c96c",
                firstName: "Rahul",
                lastName: "Aggarwal",
                email: "raggarwal@cargojet.com",
                crewInfo: {
                  positions: ["CA", "NF"],
                },
              },
            ],
            assignmentType: {
              _id: "6086e97ac6923758d24a60aa",
              title: "GDO",
              defaultColor: "FFC000",
              visibleBeforeRelease: false,
              allowableOnPairing: false,
              isDuty: false,
            },
            tier: 10,
            awarded: false,
            awardedAt: null,
            awardedBy: null,
            prefRank: 2,
            createdAt: "2022-09-13T01:05:20.135Z",
          },
        ],
      },
      "3": {
        displayBidPairings: [
          {
            _id: "631a071242f9630009a31763",
            baseICAO: "CYHM",
            positions: [
              {
                position: "CA",
                openFlyingStatus: 0,
              },
            ],
            start: 1664338500000,
            end: 1664395200000,
            eventGroups: [
              {
                flights: [
                  {
                    _id: "62c6ca63b1ec9f000977edb0",
                    flightNumber: 571,
                    origin: "CYHM",
                    destination: "CYWG",
                    actualOut: 1664342100000,
                    actualIn: 1664351100000,
                    flightType: {
                      color: "009933",
                    },
                  },
                  {
                    _id: "62c6ca5fb1ec9f000977ed48",
                    flightNumber: 591,
                    origin: "CYWG",
                    destination: "CYQR",
                    actualOut: 1664356500000,
                    actualIn: 1664360700000,
                    flightType: {
                      color: "009933",
                    },
                  },
                ],
                nonFlyingAssignments: [],
                positioningFlights: [
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "631a071242f9630009a31766",
                    origin: "CYQR",
                    destination: "CYYZ",
                    outTime: 1664379300000,
                    inTime: 1664389800000,
                    airlineIATA: "WO",
                    flightNumber: 322,
                  },
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "631a071242f9630009a31767",
                    origin: "CYYZ",
                    destination: "CYHM",
                    outTime: 1664391000000,
                    inTime: 1664394300000,
                    airlineIATA: "LM",
                    flightNumber: 0,
                  },
                ],
                groundEvents: [],
              },
            ],
            logicModifiers: [
              {
                _id: "631a07650a22220009c88578",
                logicModifier: {
                  allowableOnDay: false,
                  allowableOnPairing: true,
                  allowableOn: "duty",
                  _id: "60306e09589a10f79999df80",
                  custom: null,
                  title: "Line Check (LC)",
                  description: "Line Check",
                  isActive: true,
                  color: "079aa2",
                  createdAt: 1612777219293,
                  createdBy: "000000000000000000000000",
                  customSchema: null,
                  id: "60306e09589a10f79999df80",
                },
                id: "631a07650a22220009c88578",
              },
            ],
            shortId: "U2JZ",
            checkInOutOverrides: [],
            shortDescription: "571/591/[WO322]/[LM0]",
            bidPairingId: "631f467e082a02e32a1a6c01",
            awarded: false,
            awardedAt: null,
            awardedBy: null,
            assigned: false,
            prefRank: 3,
            createdAt: "2022-09-12T18:50:12.219Z",
          },
          {
            _id: "6319ea7ed12956000963b8b9",
            baseICAO: "CYHM",
            positions: [
              {
                position: "CA",
                openFlyingStatus: 0,
              },
            ],
            start: 1664044980000,
            end: 1664310900000,
            eventGroups: [
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "6319eacad289c00009a0564b",
                    origin: "CYHM",
                    destination: "CYYZ",
                    outTime: 1664045880000,
                    inTime: 1664049180000,
                    airlineIATA: "LM",
                    flightNumber: 0,
                  },
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "6319eacad289c00009a0564c",
                    origin: "CYYZ",
                    destination: "KMIA",
                    outTime: 1664056380000,
                    inTime: 1664068200000,
                    airlineIATA: "AA",
                    flightNumber: 1572,
                  },
                ],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [
                  {
                    _id: "62ed303358fb2f00092a8d07",
                    location: "KMIA",
                    start: 1664115300000,
                    end: 1664129700000,
                    isFullDay: false,
                    assignmentType: {
                      _id: "6086e97ac6923758d24a60b6",
                      title: "SIM",
                      defaultColor: "6FF2F9",
                    },
                  },
                ],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [
                  {
                    _id: "62ed303358fb2f00092a8d09",
                    location: "KMIA",
                    start: 1664201700000,
                    end: 1664216100000,
                    isFullDay: false,
                    assignmentType: {
                      _id: "6086e97ac6923758d24a60b6",
                      title: "SIM",
                      defaultColor: "6FF2F9",
                    },
                  },
                ],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "62ed303358fb2f00092a8d0b",
                    origin: "KMIA",
                    destination: "KCVG",
                    outTime: 1664287200000,
                    inTime: 1664299800000,
                    airlineIATA: "W8",
                    flightNumber: 9811,
                    flight_id: "62ec01f86026310009fa4aba",
                  },
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "62ed303358fb2f00092a8d0c",
                    origin: "KCVG",
                    destination: "CYHM",
                    outTime: 1664303400000,
                    inTime: 1664310000000,
                    airlineIATA: "W8",
                    flightNumber: 9811,
                    flight_id: "62ec01f86026310009fa4abc",
                  },
                ],
                groundEvents: [],
              },
            ],
            logicModifiers: [
              {
                _id: "62ed303358fb2f00092a8d0d",
                logicModifier: {
                  allowableOnDay: false,
                  allowableOnPairing: true,
                  allowableOn: "none",
                  _id: "62e969f70d599f08223d8e77",
                  title: "TRN",
                  description: "Training",
                  isActive: true,
                  color: "570CED",
                  createdAt: 867661001,
                  createdBy: "000000000000000000000000",
                  modifiedAt: 867661001,
                  id: "62e969f70d599f08223d8e77",
                },
                id: "62ed303358fb2f00092a8d0d",
              },
            ],
            shortId: "GW3D",
            checkInOutOverrides: [
              {
                inout: true,
                time: 1664044980000,
                eventGroup: 0,
              },
            ],
            shortDescription: "[LM0]/[AA1572]/<KMIA>/SIM/<KMIA^1>/SIM/<KMIA^1>/[W89811]",
            bidPairingId: "631f467e082a02e32a1a6c0f",
            awarded: false,
            awardedAt: null,
            awardedBy: null,
            assigned: false,
            prefRank: 3,
            createdAt: "2022-09-12T19:00:31.115Z",
          },
          {
            _id: "630f73980629d90009e55d50",
            baseICAO: "CYHM",
            positions: [
              {
                position: "CA",
                openFlyingStatus: 1,
              },
              {
                position: "FO",
                openFlyingStatus: 1,
              },
            ],
            start: 1663699380000,
            end: 1663929300000,
            eventGroups: [
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "630f73980629d90009e55d55",
                    origin: "CYHM",
                    destination: "CYYZ",
                    outTime: 1663700280000,
                    inTime: 1663703580000,
                    airlineIATA: "LM",
                    flightNumber: 0,
                  },
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "630f73980629d90009e55d56",
                    origin: "CYYZ",
                    destination: "KMIA",
                    outTime: 1663710780000,
                    inTime: 1663722600000,
                    airlineIATA: "AA",
                    flightNumber: 1572,
                  },
                ],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [
                  {
                    _id: "630e1ea5e7354e0009bb333d",
                    flightNumber: 1557,
                    origin: "KMIA",
                    destination: "SCEL",
                    actualOut: 1663794000000,
                    actualIn: 1663825500000,
                    flightType: {
                      color: "009933",
                    },
                  },
                ],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [],
                groundEvents: [],
              },
              {
                flights: [],
                nonFlyingAssignments: [],
                positioningFlights: [
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "630f73980629d90009e55d57",
                    origin: "SCEL",
                    destination: "CYYZ",
                    outTime: 1663884900000,
                    inTime: 1663923900000,
                    airlineIATA: "AC",
                    flightNumber: 93,
                  },
                  {
                    discriminator: "IDisplayPositioningFlight",
                    _id: "630f73980629d90009e55d58",
                    origin: "CYYZ",
                    destination: "CYHM",
                    outTime: 1663925100000,
                    inTime: 1663928400000,
                    airlineIATA: "LM",
                    flightNumber: 0,
                  },
                ],
                groundEvents: [],
              },
            ],
            logicModifiers: [],
            shortId: "JZKN",
            checkInOutOverrides: [
              {
                inout: true,
                time: 1663699380000,
                eventGroup: 0,
              },
            ],
            shortDescription: "[LM0]/[AA1572]/<KMIA^1>/1557/<SCEL>/[AC93]/[LM0]",
            bidPairingId: "631f467e082a02e32a1a6c2f",
            awarded: false,
            awardedAt: null,
            awardedBy: null,
            assigned: false,
            prefRank: 3,
            createdAt: "2022-09-12T19:28:42.606Z",
          },
        ],
        displayBidNFAs: [
          {
            _id: "631fd3e244c5540a6e3ddbd7",
            start: 1666497600000,
            end: 1666583999999,
            locationICAO: "CYHM",
            locationTimezoneId: "America/Toronto",
            crew: [
              {
                _id: "6090c34a3e4804ec36f1c96c",
                firstName: "Rahul",
                lastName: "Aggarwal",
                email: "raggarwal@cargojet.com",
                crewInfo: {
                  positions: ["CA", "NF"],
                },
              },
            ],
            assignmentType: {
              _id: "6086e97ac6923758d24a60aa",
              title: "GDO",
              defaultColor: "FFC000",
              visibleBeforeRelease: false,
              allowableOnPairing: false,
              isDuty: false,
            },
            tier: 8,
            awarded: false,
            awardedAt: null,
            awardedBy: null,
            prefRank: 3,
            createdAt: "2022-09-13T00:50:42.066Z",
          },
          {
            _id: "631fd84481bdfe0bf9ef796e",
            start: 1665374400000,
            end: 1665460799999,
            locationICAO: "CYHM",
            locationTimezoneId: "America/Toronto",
            crew: [
              {
                _id: "6090c34a3e4804ec36f1c96c",
                firstName: "Rahul",
                lastName: "Aggarwal",
                email: "raggarwal@cargojet.com",
                crewInfo: {
                  positions: ["CA", "NF"],
                },
              },
            ],
            assignmentType: {
              _id: "6086e97ac6923758d24a60aa",
              title: "GDO",
              defaultColor: "FFC000",
              visibleBeforeRelease: false,
              allowableOnPairing: false,
              isDuty: false,
            },
            tier: 1,
            awarded: false,
            awardedAt: null,
            awardedBy: null,
            prefRank: 3,
            createdAt: "2022-09-13T01:09:24.110Z",
          },
        ],
      },
    },
    createdAt: 1662993945761,
    createdBy: "5e3884893eedde3cc0566376",
    modifiedAt: 1663031487526,
  },
};

export const bidPackageExample = {
  bidPackage: {
    isDisabled: false,
    releaseScheduleAt: "2022-08-06T00:00:00.000Z",
    positions: ["CA"],
    crewGroups: ["Line Pilot"],
    _id: "630667d2890e9300097f9142",
    bidWindowOpen: "2022-09-01T00:00:00.000Z",
    bidWindowClose: "2022-09-15T00:00:00.000Z",
    bidBlockStart: "2022-09-17T00:00:00.000Z",
    bidBlockEnd: "2022-10-06T00:00:00.000Z",
    title: "test package claude 1",
    nonFlyingAssignments: [
      {
        nfaType: {
          _id: "61441236f3fa7f38907687bb",
          _old_id: null,
          _old_OC: null,
          title: "SMB",
          description: "Simulator B",
          allowableOnPairing: true,
          defaultColor: "6FF2F9",
          isDuty: true,
          earnsPerDiemDefault: true,
          earnsMealAllowanceDefault: false,
          defaultCreditRate: 1.0,
          defaultMinCredit: 4.0,
          isActiveAssignment: true,
          isDayOff: false,
          visibleBeforeRelease: false,
          canBankDuty: true,
          enabled: true,
          createdBy: "000000000000000000000000",
          createdAt: 867661001,
          startTime: {
            hours: 8.0,
            minutes: 5.0,
          },
          endTime: {
            hours: 15.0,
            minutes: 45.0,
          },
          reserveType: 0,
          isOnDutyRest: false,
          thirdPartyRef: {},
          foreignRef: [],
        },
        maxAmount: 2,
      },
      {
        nfaType: {
          isOnDutyRest: false,
          _id: "60b408367fa31275b433879d",
          _old_id: null,
          _old_OC: null,
          id: "60b408367fa31275b433879d",
          title: "ACP",
          description: "ACP Course",
          allowableOnPairing: true,
          defaultColor: "6FF2F9",
          isDuty: true,
          earnsPerDiemDefault: true,
          earnsMealAllowanceDefault: false,
          defaultCreditRate: 1,
          defaultMinCredit: 4,
          isActiveAssignment: true,
          isDayOff: false,
          visibleBeforeRelease: false,
          canBankDuty: true,
          enabled: true,
          createdBy: "000000000000000000000000",
          createdAt: 867661001,
          endTime: {
            hours: 17,
            minutes: 0,
          },
          startTime: {
            hours: 9,
            minutes: 0,
          },
          reserveType: 0,
          foreignRef: [],
        },
        maxAmount: 2,
      },
      {
        nfaType: {
          isOnDutyRest: false,
          _id: "6086e97ac6923758d24a60aa",
          foreignRef: [
            {
              foreignId: "GD",
              system: "sabre",
            },
          ],
          title: "GDO",
          description: "Guaranteed Day Off",
          allowableOnPairing: false,
          defaultColor: "FFC000",
          isDuty: false,
          earnsPerDiemDefault: false,
          earnsMealAllowanceDefault: false,
          defaultCreditRate: 0,
          defaultMinCredit: 0,
          isActiveAssignment: false,
          isDayOff: true,
          visibleBeforeRelease: false,
          canBankDuty: false,
          enabled: true,
          createdBy: "000000000000000000000000",
          createdAt: "1970-01-11T01:01:01.001Z",
          endTime: null,
          startTime: null,
          reserveType: 0,
          modifiedAt: "1970-01-11T01:01:01.001Z",
          id: "6086e97ac6923758d24a60aa",
        },
        maxAmount: 10,
      },
    ],
    createdAt: 1661364178073,
    createdBy: "5e3884893eedde3cc05665ab",
    modifiedAt: 1663100615522,
    modifiedBy: "5e3884893eedde3cc05665ab",
    __v: 4,
    id: "630667d2890e9300097f9142",
  },
  crewBids: [
    {
      userId: "6090c34a3e4804ec36f1c96c",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa23800094723f0",
    },
    {
      userId: "6090c34a3e4804ec36f1c96d",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa23800094723f1",
    },
    {
      userId: "6090c34a3e4804ec36f1c96e",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa23800094723f2",
    },
    {
      userId: "6090c34a3e4804ec36f1c971",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa23800094723f3",
    },
    {
      userId: "6090c34a3e4804ec36f1c974",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa23800094723f4",
    },
    {
      userId: "6090c34a3e4804ec36f1c975",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa23800094723f5",
    },
    {
      userId: "6090c34a3e4804ec36f1c976",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa23800094723f6",
    },
    {
      userId: "6090c34a3e4804ec36f1c978",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa23800094723f7",
    },
    {
      userId: "6090c34a3e4804ec36f1c979",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa23800094723f8",
    },
    {
      userId: "6090c34a3e4804ec36f1c97a",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa23800094723f9",
    },
    {
      userId: "6090c34a3e4804ec36f1c97d",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa23800094723fa",
    },
    {
      userId: "6090c34a3e4804ec36f1c981",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa23800094723fb",
    },
    {
      userId: "6090c34a3e4804ec36f1c982",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa23800094723fc",
    },
    {
      userId: "6090c34a3e4804ec36f1c983",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa23800094723fd",
    },
    {
      userId: "6090c34a3e4804ec36f1c986",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa23800094723fe",
    },
    {
      userId: "6090c34a3e4804ec36f1c988",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa23800094723ff",
    },
    {
      userId: "6090c34a3e4804ec36f1c989",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472400",
    },
    {
      userId: "6090c34a3e4804ec36f1c98a",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472401",
    },
    {
      userId: "6090c34a3e4804ec36f1c98b",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472402",
    },
    {
      userId: "6090c34a3e4804ec36f1c98c",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472403",
    },
    {
      userId: "6090c34a3e4804ec36f1c98d",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472404",
    },
    {
      userId: "6090c34a3e4804ec36f1c98e",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472405",
    },
    {
      userId: "6090c34a3e4804ec36f1c98f",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472406",
    },
    {
      userId: "6090c34a3e4804ec36f1c991",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472407",
    },
    {
      userId: "6090c34a3e4804ec36f1c992",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472408",
    },
    {
      userId: "6090c34a3e4804ec36f1c993",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472409",
    },
    {
      userId: "6090c34a3e4804ec36f1c994",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947240a",
    },
    {
      userId: "6090c34a3e4804ec36f1c996",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947240b",
    },
    {
      userId: "6090c34a3e4804ec36f1c998",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947240c",
    },
    {
      userId: "6090c34a3e4804ec36f1c999",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947240d",
    },
    {
      userId: "6090c34a3e4804ec36f1c99a",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947240e",
    },
    {
      userId: "6090c34a3e4804ec36f1c99b",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947240f",
    },
    {
      userId: "6090c34a3e4804ec36f1c99c",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472410",
    },
    {
      userId: "6090c34a3e4804ec36f1c99d",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472411",
    },
    {
      userId: "6090c34a3e4804ec36f1c9a1",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472412",
    },
    {
      userId: "6090c34a3e4804ec36f1c9a3",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472413",
    },
    {
      userId: "6090c34a3e4804ec36f1c9a4",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472414",
    },
    {
      userId: "6090c34a3e4804ec36f1c9a5",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472415",
    },
    {
      userId: "6090c34a3e4804ec36f1c9a6",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472416",
    },
    {
      userId: "6090c34a3e4804ec36f1c9aa",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472417",
    },
    {
      userId: "6090c34a3e4804ec36f1c9ac",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472418",
    },
    {
      userId: "6090c34a3e4804ec36f1c9ad",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472419",
    },
    {
      userId: "6090c34a3e4804ec36f1c9ae",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947241a",
    },
    {
      userId: "6090c34a3e4804ec36f1c9b0",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947241b",
    },
    {
      userId: "6090c34a3e4804ec36f1c9b1",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947241c",
    },
    {
      userId: "6090c34a3e4804ec36f1c9b2",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947241d",
    },
    {
      userId: "6090c34a3e4804ec36f1c9b3",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947241e",
    },
    {
      userId: "6090c34a3e4804ec36f1c9b4",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947241f",
    },
    {
      userId: "6090c34a3e4804ec36f1c9b6",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472420",
    },
    {
      userId: "6090c34a3e4804ec36f1c9b8",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472421",
    },
    {
      userId: "6090c34a3e4804ec36f1c9b9",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472422",
    },
    {
      userId: "6090c34a3e4804ec36f1c9ba",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472423",
    },
    {
      userId: "6090c34a3e4804ec36f1c9bb",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472424",
    },
    {
      userId: "6090c34a3e4804ec36f1c9bc",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472425",
    },
    {
      userId: "6090c34a3e4804ec36f1c9be",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472426",
    },
    {
      userId: "6090c34a3e4804ec36f1c9bf",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472427",
    },
    {
      userId: "6090c34a3e4804ec36f1c9c0",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472428",
    },
    {
      userId: "6090c34a3e4804ec36f1c9c2",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472429",
    },
    {
      userId: "6090c34a3e4804ec36f1c9c3",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947242a",
    },
    {
      userId: "6090c34a3e4804ec36f1c9c7",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947242b",
    },
    {
      userId: "6090c34a3e4804ec36f1c9cc",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947242c",
    },
    {
      userId: "6090c34a3e4804ec36f1c9cd",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947242d",
    },
    {
      userId: "6090c34a3e4804ec36f1c9ce",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947242e",
    },
    {
      userId: "6090c34a3e4804ec36f1c9cf",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947242f",
    },
    {
      userId: "6090c34a3e4804ec36f1c9d3",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472430",
    },
    {
      userId: "6090c34a3e4804ec36f1c9d4",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472431",
    },
    {
      userId: "6090c34a3e4804ec36f1c9d6",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472432",
    },
    {
      userId: "6090c34a3e4804ec36f1c9d9",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472433",
    },
    {
      userId: "6090c34a3e4804ec36f1c9da",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472434",
    },
    {
      userId: "6090c34a3e4804ec36f1c9db",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472435",
    },
    {
      userId: "6090c34a3e4804ec36f1c9dc",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472436",
    },
    {
      userId: "6090c34a3e4804ec36f1c9dd",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472437",
    },
    {
      userId: "6090c34a3e4804ec36f1c9df",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472438",
    },
    {
      userId: "6090c34a3e4804ec36f1c9e0",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472439",
    },
    {
      userId: "6090c34a3e4804ec36f1c9e1",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947243a",
    },
    {
      userId: "6090c34a3e4804ec36f1c9e3",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947243b",
    },
    {
      userId: "6090c34a3e4804ec36f1c9e4",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947243c",
    },
    {
      userId: "6090c34a3e4804ec36f1c9e5",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947243d",
    },
    {
      userId: "6090c34a3e4804ec36f1c9e6",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947243e",
    },
    {
      userId: "6090c34a3e4804ec36f1c9e8",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947243f",
    },
    {
      userId: "6090c34a3e4804ec36f1c9e9",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472440",
    },
    {
      userId: "6090c34a3e4804ec36f1c9ea",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472441",
    },
    {
      userId: "6090c34a3e4804ec36f1c9eb",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472442",
    },
    {
      userId: "6090c34a3e4804ec36f1c9ec",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472443",
    },
    {
      userId: "6090c34a3e4804ec36f1c9ed",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472444",
    },
    {
      userId: "6090c34a3e4804ec36f1c9ee",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472445",
    },
    {
      userId: "6090c34a3e4804ec36f1c9ef",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472446",
    },
    {
      userId: "6090c34a3e4804ec36f1c9f0",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472447",
    },
    {
      userId: "6090c34a3e4804ec36f1c9f1",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472448",
    },
    {
      userId: "6090c34a3e4804ec36f1c9f3",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa2380009472449",
    },
    {
      userId: "6090c34a3e4804ec36f1c9f4",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947244a",
    },
    {
      userId: "6090c34a3e4804ec36f1c9f5",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947244b",
    },
    {
      userId: "6090c34a3e4804ec36f1c9f6",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947244c",
    },
    {
      userId: "6090c34a3e4804ec36f1c9f7",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947244d",
    },
    {
      userId: "6090c34a3e4804ec36f1c9f8",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc52cfa238000947244e",
    },
    {
      userId: "6090c34a3e4804ec36f1c9fb",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947244f",
    },
    {
      userId: "6090c34a3e4804ec36f1c9fc",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472450",
    },
    {
      userId: "6090c34a3e4804ec36f1c9fd",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472451",
    },
    {
      userId: "6090c34a3e4804ec36f1c9fe",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472452",
    },
    {
      userId: "6090c34a3e4804ec36f1c9ff",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472453",
    },
    {
      userId: "6090c34a3e4804ec36f1ca01",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472454",
    },
    {
      userId: "6090c34a3e4804ec36f1ca02",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472455",
    },
    {
      userId: "6090c34a3e4804ec36f1ca03",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472456",
    },
    {
      userId: "6090c34a3e4804ec36f1ca04",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472457",
    },
    {
      userId: "6090c34a3e4804ec36f1ca05",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472458",
    },
    {
      userId: "6090c34a3e4804ec36f1ca07",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472459",
    },
    {
      userId: "6090c34a3e4804ec36f1ca08",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947245a",
    },
    {
      userId: "6090c34a3e4804ec36f1ca0b",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947245b",
    },
    {
      userId: "6090c34a3e4804ec36f1ca0c",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947245c",
    },
    {
      userId: "6090c34a3e4804ec36f1ca0d",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947245d",
    },
    {
      userId: "6090c34a3e4804ec36f1ca0f",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947245e",
    },
    {
      userId: "6090c34a3e4804ec36f1ca11",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947245f",
    },
    {
      userId: "6090c34a3e4804ec36f1ca12",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472460",
    },
    {
      userId: "6090c34a3e4804ec36f1ca13",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472461",
    },
    {
      userId: "6090c34a3e4804ec36f1ca14",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472462",
    },
    {
      userId: "6090c34a3e4804ec36f1ca15",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472463",
    },
    {
      userId: "6090c34a3e4804ec36f1ca17",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472464",
    },
    {
      userId: "6090c34a3e4804ec36f1ca19",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472465",
    },
    {
      userId: "6090c34a3e4804ec36f1ca1b",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472466",
    },
    {
      userId: "6090c34a3e4804ec36f1ca1d",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472467",
    },
    {
      userId: "6090c34a3e4804ec36f1ca20",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472468",
    },
    {
      userId: "6090c34a3e4804ec36f1ca21",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472469",
    },
    {
      userId: "6090c34a3e4804ec36f1ca23",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947246a",
    },
    {
      userId: "6090c34a3e4804ec36f1ca24",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947246b",
    },
    {
      userId: "6090c34a3e4804ec36f1ca26",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947246c",
    },
    {
      userId: "6090c34a3e4804ec36f1ca27",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947246d",
    },
    {
      userId: "6090c34a3e4804ec36f1ca29",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947246e",
    },
    {
      userId: "6090c34a3e4804ec36f1ca2a",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947246f",
    },
    {
      userId: "6090c34a3e4804ec36f1ca2c",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472470",
    },
    {
      userId: "6090c34a3e4804ec36f1ca2d",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472471",
    },
    {
      userId: "6090c34a3e4804ec36f1ca2e",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472472",
    },
    {
      userId: "6090c34a3e4804ec36f1ca2f",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472473",
    },
    {
      userId: "6090c34a3e4804ec36f1ca30",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472474",
    },
    {
      userId: "6090c34a3e4804ec36f1ca31",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472475",
    },
    {
      userId: "6090c34a3e4804ec36f1ca32",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472476",
    },
    {
      userId: "6090c34a3e4804ec36f1ca33",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472477",
    },
    {
      userId: "6090c34a3e4804ec36f1ca36",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472478",
    },
    {
      userId: "6090c34a3e4804ec36f1ca37",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472479",
    },
    {
      userId: "6090c34a3e4804ec36f1ca38",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947247a",
    },
    {
      userId: "6090c34a3e4804ec36f1ca39",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947247b",
    },
    {
      userId: "6090c34a3e4804ec36f1ca3a",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947247c",
    },
    {
      userId: "6090c34a3e4804ec36f1ca3f",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947247d",
    },
    {
      userId: "6090c34a3e4804ec36f1ca41",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947247e",
    },
    {
      userId: "6090c34a3e4804ec36f1ca42",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947247f",
    },
    {
      userId: "6090c34a3e4804ec36f1ca43",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472480",
    },
    {
      userId: "6090c34a3e4804ec36f1ca45",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472481",
    },
    {
      userId: "6090c34a3e4804ec36f1ca46",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472482",
    },
    {
      userId: "6090c34a3e4804ec36f1ca47",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472483",
    },
    {
      userId: "6090c34a3e4804ec36f1ca49",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472484",
    },
    {
      userId: "6090c34a3e4804ec36f1ca4a",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472485",
    },
    {
      userId: "6090c34a3e4804ec36f1ca4c",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472486",
    },
    {
      userId: "6090c34a3e4804ec36f1ca4d",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472487",
    },
    {
      userId: "6090c34a3e4804ec36f1ca4e",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472488",
    },
    {
      userId: "6090c34a3e4804ec36f1ca4f",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472489",
    },
    {
      userId: "6090c34a3e4804ec36f1ca50",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947248a",
    },
    {
      userId: "6090c34a3e4804ec36f1ca52",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947248b",
    },
    {
      userId: "6090c34a3e4804ec36f1ca53",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947248c",
    },
    {
      userId: "6090c34a3e4804ec36f1ca55",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947248d",
    },
    {
      userId: "6090c34a3e4804ec36f1ca58",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947248e",
    },
    {
      userId: "6090c34a3e4804ec36f1ca59",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947248f",
    },
    {
      userId: "6090c34a3e4804ec36f1ca5b",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472490",
    },
    {
      userId: "6090c34a3e4804ec36f1ca5d",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472491",
    },
    {
      userId: "6090c34a3e4804ec36f1ca5e",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472492",
    },
    {
      userId: "6090c34a3e4804ec36f1ca60",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472493",
    },
    {
      userId: "6090c34a3e4804ec36f1ca61",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472494",
    },
    {
      userId: "6090c34a3e4804ec36f1ca66",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472495",
    },
    {
      userId: "6090c34a3e4804ec36f1ca67",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472496",
    },
    {
      userId: "6090c34a3e4804ec36f1ca68",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472497",
    },
    {
      userId: "6090c34a3e4804ec36f1ca69",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472498",
    },
    {
      userId: "6090c34a3e4804ec36f1ca6a",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472499",
    },
    {
      userId: "6090c34a3e4804ec36f1ca6c",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947249a",
    },
    {
      userId: "6090c34a3e4804ec36f1ca6d",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947249b",
    },
    {
      userId: "6090c34a3e4804ec36f1ca6e",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947249c",
    },
    {
      userId: "6090c34a3e4804ec36f1ca70",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947249d",
    },
    {
      userId: "6090c34a3e4804ec36f1ca72",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947249e",
    },
    {
      userId: "6090c34a3e4804ec36f1ca73",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947249f",
    },
    {
      userId: "6090c34a3e4804ec36f1ca74",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724a0",
    },
    {
      userId: "6090c34a3e4804ec36f1ca75",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724a1",
    },
    {
      userId: "6090c34a3e4804ec36f1ca77",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724a2",
    },
    {
      userId: "6090c34a3e4804ec36f1ca7a",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724a3",
    },
    {
      userId: "6090c34a3e4804ec36f1ca7b",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724a4",
    },
    {
      userId: "6090c34a3e4804ec36f1ca7c",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724a5",
    },
    {
      userId: "6090c34a3e4804ec36f1ca7d",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724a6",
    },
    {
      userId: "6090c34a3e4804ec36f1ca7e",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724a7",
    },
    {
      userId: "6090c34a3e4804ec36f1ca7f",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724a8",
    },
    {
      userId: "6090c34a3e4804ec36f1ca81",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724a9",
    },
    {
      userId: "6090c34a3e4804ec36f1ca82",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724aa",
    },
    {
      userId: "6090c34a3e4804ec36f1ca83",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724ab",
    },
    {
      userId: "6090c34a3e4804ec36f1ca85",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724ac",
    },
    {
      userId: "6090c34a3e4804ec36f1ca88",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724ad",
    },
    {
      userId: "6090c34a3e4804ec36f1ca89",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724ae",
    },
    {
      userId: "6090c34a3e4804ec36f1ca8a",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724af",
    },
    {
      userId: "6090c34a3e4804ec36f1ca8b",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724b0",
    },
    {
      userId: "6090c34a3e4804ec36f1ca8c",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724b1",
    },
    {
      userId: "6090c34a3e4804ec36f1ca8d",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724b2",
    },
    {
      userId: "6090c34a3e4804ec36f1ca8e",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724b3",
    },
    {
      userId: "6090c34a3e4804ec36f1ca90",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724b4",
    },
    {
      userId: "6090c34a3e4804ec36f1ca91",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724b5",
    },
    {
      userId: "6090c34a3e4804ec36f1ca92",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724b6",
    },
    {
      userId: "6090c34a3e4804ec36f1ca94",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724b7",
    },
    {
      userId: "609c3434d72f410009bac04e",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724b8",
    },
    {
      userId: "60ca17c446f2fd000909cdbc",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724b9",
    },
    {
      userId: "60ca1dd37a886e000820bb94",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724ba",
    },
    {
      userId: "60ca1faada08a300099cf788",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724bb",
    },
    {
      userId: "60ca2747785098000883e555",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724bc",
    },
    {
      userId: "60ca2b4bf605670008685228",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724bd",
    },
    {
      userId: "60ca34b9114fa10008b8de5e",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724be",
    },
    {
      userId: "60ca47c51668ff0008b1fbb2",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724bf",
    },
    {
      userId: "60ca4c0f03bf95000812ec19",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724c0",
    },
    {
      userId: "60ca4f7eb9e3500009dabf94",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724c1",
    },
    {
      userId: "60ca5158b9e3500009dabf9a",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724c2",
    },
    {
      userId: "60ca5744b734180008875da7",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724c3",
    },
    {
      userId: "60ca5845b734180008875daa",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724c4",
    },
    {
      userId: "60e75de3ac63ef0008119a87",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724c5",
    },
    {
      userId: "60e762987d6a70000854bc8a",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724c6",
    },
    {
      userId: "60e765cad277c300081de300",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724c7",
    },
    {
      userId: "60e766acd277c300081de303",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724c8",
    },
    {
      userId: "60f5b68c87953300086c08ce",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724c9",
    },
    {
      userId: "6115683e57f35f00092192ed",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724ca",
    },
    {
      userId: "61157d1d698407000886ac32",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724cb",
    },
    {
      userId: "61166477965a0100099a8274",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724cc",
    },
    {
      userId: "611a705ce28092000938693d",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724cd",
    },
    {
      userId: "6144dbe7cbfc280009448da7",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724ce",
    },
    {
      userId: "6144dd20cbfc280009448dac",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724cf",
    },
    {
      userId: "6144e6387696e70009a25e5e",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724d0",
    },
    {
      userId: "6144e7467696e70009a25e63",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724d1",
    },
    {
      userId: "6144e92b48a4ff0009abed07",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724d2",
    },
    {
      userId: "6148a26f65fab80009aba6ea",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724d3",
    },
    {
      userId: "6148a4683106300009f58730",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724d4",
    },
    {
      userId: "6148a941bb0f700009d43aae",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724d5",
    },
    {
      userId: "614c9fa83b9eda000926bd4a",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724d6",
    },
    {
      userId: "61688893fe16f80009a848c7",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724d7",
    },
    {
      userId: "616889defe16f80009a848cc",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724d8",
    },
    {
      userId: "61688b61a8e0aa0008ab112f",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724d9",
    },
    {
      userId: "61688c58a8e0aa0008ab1134",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724da",
    },
    {
      userId: "61688d49a8e0aa0008ab1139",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724db",
    },
    {
      userId: "61688e69a8e0aa0008ab113e",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724dc",
    },
    {
      userId: "6169b2e64432780009008bdc",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724dd",
    },
    {
      userId: "6169b4304432780009008be1",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724de",
    },
    {
      userId: "6169b77b8c9a360009bcfddc",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724df",
    },
    {
      userId: "6169b90042bc910009efc4d7",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724e0",
    },
    {
      userId: "6169bb06aeb9340009454976",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724e1",
    },
    {
      userId: "61940412bb52230009375b8e",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724e2",
    },
    {
      userId: "61940addd2b74700090a07a5",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724e3",
    },
    {
      userId: "61940eccb7f28c0009eafef1",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724e4",
    },
    {
      userId: "6194107a476a92000996556d",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724e5",
    },
    {
      userId: "6194135d32de5d0009f2d0a5",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724e6",
    },
    {
      userId: "61941680a27aa90009d77561",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724e7",
    },
    {
      userId: "61941ae1ebf9dd0009aa1645",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724e8",
    },
    {
      userId: "61af627bef8e1e0008d081ff",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724e9",
    },
    {
      userId: "61bcaf2859914a0009b8a9c9",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724ea",
    },
    {
      userId: "61bcb0edf75109000951ac33",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724eb",
    },
    {
      userId: "61bcb24fa2af480009705deb",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724ec",
    },
    {
      userId: "61bcbd61b6ed030009be3f85",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724ed",
    },
    {
      userId: "61bcc428d2d2be00091611f5",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724ee",
    },
    {
      userId: "61bcc577c4b4730009de4732",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724ef",
    },
    {
      userId: "61bcc6f59121600009ea5dd8",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724f0",
    },
    {
      userId: "61bcc9b03a17770009d57fb3",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724f1",
    },
    {
      userId: "61f30c7e7918490009fd12d2",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724f2",
    },
    {
      userId: "61f30e7f3528d30009604c35",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724f3",
    },
    {
      userId: "61f3100323e99300099f4e44",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724f4",
    },
    {
      userId: "61f31175cc08c80009ebc490",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724f5",
    },
    {
      userId: "61f312becc08c80009ebc497",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724f6",
    },
    {
      userId: "61f31a0c4420a6000947223b",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724f7",
    },
    {
      userId: "61f31c1311cfae00090a9ee7",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724f8",
    },
    {
      userId: "61f31dd1f025870009456688",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724f9",
    },
    {
      userId: "62224d33094e550008b6a263",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724fa",
    },
    {
      userId: "62225908eb216800092aa0fb",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724fb",
    },
    {
      userId: "62225b7445beb10009869b00",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724fc",
    },
    {
      userId: "62225f4e1c4eb90009154243",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724fd",
    },
    {
      userId: "622266e1cde0db0009194076",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724fe",
    },
    {
      userId: "622269679bbec90009a14b89",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa23800094724ff",
    },
    {
      userId: "62226b80ad6af10009c6765a",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472500",
    },
    {
      userId: "62226d32e9f3440009212662",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472501",
    },
    {
      userId: "62262c807000e30009fada19",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472502",
    },
    {
      userId: "6226332c3fb7b7000932a2b9",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472503",
    },
    {
      userId: "622634d0b0124800093a312a",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472504",
    },
    {
      userId: "62263c49ad3ae70009a06d0d",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472505",
    },
    {
      userId: "62263f49f8ca710009508c3c",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472506",
    },
    {
      userId: "622649296dfddf00095a6e16",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472507",
    },
    {
      userId: "62264a60831ae40009330db3",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472508",
    },
    {
      userId: "6245fad41978dd00093ae2ee",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472509",
    },
    {
      userId: "6245ff18982c0b0009e2aa29",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947250a",
    },
    {
      userId: "624601da9398ba0009a69560",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947250b",
    },
    {
      userId: "6246039bfffcde00092144b2",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947250c",
    },
    {
      userId: "624604defffcde00092144b9",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947250d",
    },
    {
      userId: "624606a5c7366d0009f340d1",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947250e",
    },
    {
      userId: "62460909cd97b1000925a1fc",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947250f",
    },
    {
      userId: "62460a38dc2fd700090b0365",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472510",
    },
    {
      userId: "62460d09a1ca3700097560aa",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472511",
    },
    {
      userId: "62460e4a52a4460009af96a3",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472512",
    },
    {
      userId: "62460f6600beaa0009a86c01",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472513",
    },
    {
      userId: "625086cb520ed300098a9e27",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472514",
    },
    {
      userId: "62751b0bd9241d0009844897",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472515",
    },
    {
      userId: "6275205b912b3d00095dfa51",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472516",
    },
    {
      userId: "627524a0b489c1000911943a",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472517",
    },
    {
      userId: "627525f2f67d0e0009733f4d",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472518",
    },
    {
      userId: "62752736f67d0e0009733f54",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472519",
    },
    {
      userId: "62752903b55998000934dd08",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947251a",
    },
    {
      userId: "62752aaa6337d30009897d3a",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947251b",
    },
    {
      userId: "627530605063930009c0c00b",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947251c",
    },
    {
      userId: "627534a09d558700096d82d9",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947251d",
    },
    {
      userId: "62753702a9d59a0009d8b976",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947251e",
    },
    {
      userId: "627538657f242e0009813163",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947251f",
    },
    {
      userId: "62753cbbdb2e2f000903c802",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472520",
    },
    {
      userId: "62753e114b70e600090a4276",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472521",
    },
    {
      userId: "627bf6ebee0f9600091a4d11",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472522",
    },
    {
      userId: "627bf846ee0f9600091a4d18",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472523",
    },
    {
      userId: "627bfa4600b1550009a39616",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472524",
    },
    {
      userId: "627bfc2c4cdda90009138801",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472525",
    },
    {
      userId: "627bfd634cdda90009138808",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472526",
    },
    {
      userId: "627bff685976200009a5aa3d",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472527",
    },
    {
      userId: "627c019ca1b5f6000983d1aa",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472528",
    },
    {
      userId: "627c05423ab3480009f7367c",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472529",
    },
    {
      userId: "627c13c00037b90009200788",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947252a",
    },
    {
      userId: "62aa2c200bc1590009bb4be1",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947252b",
    },
    {
      userId: "62aa2f8205332900096ec467",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947252c",
    },
    {
      userId: "62aa344a3076c70009d5ec8a",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947252d",
    },
    {
      userId: "62aa3601cd8a5e000ac5b6f9",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947252e",
    },
    {
      userId: "62aa3742cd8a5e000ac5b700",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947252f",
    },
    {
      userId: "62aa3b6a5895970009d09686",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472530",
    },
    {
      userId: "62aa3cd2e7920a00093a06ef",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472531",
    },
    {
      userId: "62aa413519d2820009e01bca",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472532",
    },
    {
      userId: "62aa439dfd2c9f000a414486",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472533",
    },
    {
      userId: "62aa45f7ad36ed0009bc1e66",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472534",
    },
    {
      userId: "62aa4aa1ad38b10009e3eb64",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472535",
    },
    {
      userId: "62aa4ba91967070009830f02",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472536",
    },
    {
      userId: "62aa4d9d6d6f990009ee7a09",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472537",
    },
    {
      userId: "62aa517b0413c5000967c1d3",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472538",
    },
    {
      userId: "62aa542016c5c50009bdff19",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472539",
    },
    {
      userId: "62c60890c5a25b0009ec545d",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947253a",
    },
    {
      userId: "62c60c93547a230009b021b8",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947253b",
    },
    {
      userId: "62c60de9547a230009b021bf",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947253c",
    },
    {
      userId: "62c60f55efbd51000932e131",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947253d",
    },
    {
      userId: "62c6115cc8c0bf0009aa789a",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947253e",
    },
    {
      userId: "62c612e4b24a840009c75743",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947253f",
    },
    {
      userId: "62c6149b498939000910610b",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472540",
    },
    {
      userId: "62c616595a601a0009e5cc7f",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472541",
    },
    {
      userId: "62c61854136e810009174724",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472542",
    },
    {
      userId: "62c619fb1a974b0009534a79",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472543",
    },
    {
      userId: "62e42cb15e4ba60009d8859c",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472544",
    },
    {
      userId: "62e42fb86935a300090599af",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472545",
    },
    {
      userId: "62e431d3cef3ef0009728f90",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472546",
    },
    {
      userId: "62ed2816866c720009f8b2d7",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472547",
    },
    {
      userId: "62ed2d817fbd1b0009466580",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472548",
    },
    {
      userId: "62ed3013d1eb4f00097fdb0f",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa2380009472549",
    },
    {
      userId: "62ed33441264fb0009d3a5de",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947254a",
    },
    {
      userId: "62ed36385ef3e0000963a354",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947254b",
    },
    {
      userId: "62ed38567da4b6000a4e6c22",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947254c",
    },
    {
      userId: "62ed3a8a06b0d200094c8710",
      pairingBids: 0,
      nfaBids: 0,
      bidId: "6320dc53cfa238000947254d",
    },
  ],
  bidPairings: [
    {
      pairingId: "62f533d17b0b89000932de08",
      bidPairingId: "6320dfef082a02e32a429048",
    },
    {
      pairingId: "6307b293be794a0009d159ce",
      bidPairingId: "6320e6ac082a02e32a434095",
    },
  ],
};
